import React from "react";

import Button from "@cayuse/shared-react.components.button";

import IconButton from "@cayuse/shared-react.components.icon-button";

const CostCategoriesButtons = ({
	isEditing,
	dictionary,
	handleReset,
	isModified,
	isLoading,
	handleSave,
	setAddCategoryModalOpen,
	isValid,
	handleEdit,
}) => {
	const cancelButton = () => (
		<Button disabled={!isEditing} onClick={handleReset} secondary>
			{dictionary.cancel || "Cancel"}
		</Button>
	);

	const editSaveButton = () => isEditing ? (
		<IconButton
			key="save"
			// icon="save"
			labelPosition="left"
			disabled={!isValid || !isModified}
			busy={isLoading}
			onClick={handleSave}
		>
			{dictionary.save || "Save"}
		</IconButton>
	) : (
		<IconButton
			key="edit"
			icon="pencil-alt"
			labelPosition="left"
			onClick={handleEdit}
		>
			{dictionary.edit || "Edit"}
		</IconButton>
	);

	const addCategoryButton = () => (
		<IconButton
			key="add"
			icon="plus"
			labelPosition="left"
			onClick={() => setAddCategoryModalOpen(true)}
		>
			{dictionary.modalHeader || "Add New"}
		</IconButton>
	);

	return ([ cancelButton(), editSaveButton(), addCategoryButton() ]);
};

export default CostCategoriesButtons;
